// app/studente/risorse.js

(function () {
    'use strict';
    var controllerId = 'risorsa';
    angular.module('app').controller(controllerId, ['common', 'bootstrap.dialog', '$rootScope', '$routeParams', '$filter', '$uibModal', 'datacontext', 'sectionMenu', risorsa]);

    function risorsa(common, bDialog, $rootScope, $routeParams, $filter, $uibModal, datacontext, sectionMenu) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');
        $rootScope.dashview = ""; // Azzera la classe dashview utile solo nelle dashboard 

        var vm = this;
        vm.title = 'Docenti';
        vm.view = 'list';       //Opzione list or detail
        vm.setView = setView;
        vm.sectionMenu = sectionMenu.setSection(vm.title);

        //Gestione sola lettura
        vm.readOnly = !$rootScope.isAuthorized('SUPER') && !$rootScope.isAuthorized('GESTORE');
        vm.super = $rootScope.isAuthorized('SUPER');
        vm.gestDid = $rootScope.isAuthorized('GESTORE');

        vm.objName = "risorsa"; //Utilizzato per pannello modale
        vm.showObjPanel = false;
        vm.record = {};
        vm.records = [];
        vm.countRecords = 0;
        vm.index = 0;
        vm.custom = false;

        vm.addDisabled = !vm.super && !vm.gestDid;

        vm.exportDisabled = false;
        vm.pageSize = 30;
        vm.page = 1;
        vm.loading = false;

        //Elenco per Ordinamento
        vm.list = {};
        vm.list.ordine = ['alfabetico'];
        vm.ordine = vm.list.ordine[0];
        vm.selectOrdine = function (item) {
            vm.ordine = item;
        };

        //Elenchi dettaglio
        vm.list.incarichi = [];
        vm.list.materie = [];

        vm.getRecord = getRecord;
        vm.getListIncarichi = getListIncarichi;
        vm.getListMaterie = getListMaterie;
        vm.getComuni = getComuni;

        //Filtro
        vm.filter = {};
        vm.filter.nominativo = '';        
        vm.fNominativo;

        //filter per Anno: default l'anno corrente o per anno impostato gi� in altre aree
        if ($rootScope.annoScolastico == 0)
            vm.fAnno = $rootScope.annoCorrente || (new Date).getFullYear();
        else
            vm.fAnno = $rootScope.annoScolastico;
        vm.filter.anno = vm.fAnno;

        //Elenchi per filtri e finestra modale di Create        
        vm.provincie = [];
        vm.comuni = [];
        vm.societa = [];
        
        //Metodi su interfaccia
        vm.cerca = cerca;
        vm.loadMore = getAllByFilter;
        vm.loadAll = getAll;

        vm.addIncarico = addIncarico;
        vm.deleteIncarico = deleteIncarico;
        vm.editIncarico = editIncarico;

        vm.deleteMateria = deleteMateria;
        vm.addMateria = addMateria;

        vm.get = getRecord;
        vm.add = addModal;
        vm.update = updateItem;
        vm.delete = deleteItem;

        //Gestione account
        vm.getAccount = getAccount;
        vm.updateAccount = updateAccount;
        vm.resetPassword = resetPassword;
        vm.invioCredenziali = invioCredenziali;

        //datapicker
        vm.open = function ($event, iOpened) {
            $event.preventDefault();
            $event.stopPropagation();

            vm.opened1 = false;
            vm.opened2 = false;
            vm.opened3 = false;
            if (iOpened == 1)
                vm.opened1 = true;
            else if (iOpened == 2)
                vm.opened2 = true;
            else if (iOpened == 3)
                vm.opened3 = true;
        };

        vm.dateOptions = {
            formatYear: 'yy',
            startingDay: 1
        };

        vm.format = 'dd/MM/yyyy';

        // ---- ACTIVATE -------
        activate();

        function activate() {
            var promises = [getListSocieta()];
            common.activateController(promises, controllerId)
                    .then(function () {
                        if ($routeParams.RisorsaId != null) {
                            setView('detail');
                            getRecord($routeParams.RisorsaId, 0);
                        }
                    });
        }

        //****************************************************
        // METODI 
        //****************************************************
        function setView(view) {
            return vm.view = view;
        }

        function cerca() {
            vm.records = [];
            vm.countRecords = 0;
            vm.page = 1;
            vm.filter.nominativo = vm.fNominativo == null ? '' : vm.fNominativo;
            vm.filter.anno = vm.fAnno == null ? -1 : vm.fAnno;
            if (vm.filter.anno != $rootScope.annoScolastico)
                $rootScope.annoScolastico = vm.filter.anno;

            vm.loading = false;
            countByFilter();
            return getAllByFilter();
        }

        function countByFilter() {
            return datacontext.super_risorsa_countAll(vm.filter.anno, vm.filter.nominativo).then(function (data) {
                if (data) {
                    vm.countRecords = data;
                }
            });
        }

        function getAllByFilter() {
            if (vm.loading === true) return;

            if (vm.countRecords == 0) countByFilter();
            else if (vm.countRecords <= vm.records.length) return;

            vm.loading = true;
            return datacontext.super_risorsa_getAll(vm.pageSize, vm.page, vm.filter.anno, vm.filter.nominativo, vm.ordine).then(function (data) {
                if (data.constructor === Array) {
                    vm.page++;
                    data.forEach(function (item) {
                        vm.records.push(item);
                    });
                }
                vm.loading = false;
            });
        }

        function getAll() {
            if (vm.records.length < vm.countRecords) {
                getAllByFilter().then(function () { getAll(); });
            }
        }

        function getRecord(id, index) {            
            if (vm.provincie.length == 0) getProvincie();

            return datacontext.risorsa_get(id).then(function (data) {
                vm.index = index;
                vm.record = data;
                vm.numIncarichi = data.stat_numIncarichi;                
                //Azzera liste
                getComuni(vm.record.ProvinciaId);
                vm.list.incarichi = [];     
                vm.list.materie = [];
                getListMaterie(id);

                setView('detail');
            });
        }
                
        function addRecord(id) {
            return datacontext.risorsa_get(id).then(function (data) {
                vm.records.push(data);
                vm.countRecords++;
            });
        }

        function updateItem() {
            return datacontext.risorsa_update(vm.record).then(function (data) {
                if (!data) {
                    cerca();
                    logSuccess('Dato salvato');
                }
                else
                    logError('Impossibile salvare il dato');
            });
        }

        function deleteItem(item) {
            if (item.Attivo) {
                logError('Non &egrave; possibile eliminare un docente attivo');
                return;
            }

            var msg = ' il docente ' + item.Cognome + ' ' + item.Nome;
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.risorsa_delete(item.Id).then(function (data) {
                    if (data != "204") return logError('Errore durante la rimozione del dato');

                    var index = vm.records.indexOf(item);
                    vm.records.splice(index, 1);
                    vm.countRecords--;
                });
            });
        }

        //Elenchi dettagli
        function getListIncarichi(id) {
            return datacontext.incarico_getAllByRisorsa(id).then(function (data) {
                vm.numIncarichi = data.length;
                if (data.constructor === Array) {
                    vm.record.sumOreDocenze = 0;
                    data.forEach(function (data) {
                        vm.record.sumOreDocenze += data.Ore;
                    });
                }
                return vm.list.incarichi = data;
            });
        }      

        function getListMaterie(id) {
            if (!vm.super)
                return;

            return datacontext.super_materia_getAllByDocente(id).then(function (data) {
                return vm.list.materie = data;
            });
        }

        function getProvincie() {
            if (vm.provincie.length > 0) return;

            datacontext.arrProvincie().then(function (data) {
                vm.provincie = data;
            });
        }

        function getComuni(idprov) {
            if (!idprov || idprov == 0) return vm.comuni = [];

            return datacontext.istat_comune_getAllList(idprov).then(function (data) {
                return vm.comuni = data;
            });
        }

        function getListClassi() {
            return datacontext.classe_getAllList(-1).then(function (data) {
                return data;
            });
        }            

        function getListSocieta() {
            if (!vm.super)
                return;

            return datacontext.societa_getAllList().then(function (data) {
                return vm.societa = data;
            });
        }

        //Gestione account
        function getAccount() {
            datacontext.user_getByUsername(vm.record.Username).then(function (data) {
                vm.account = data;
                vm.account.DtAttivazione = $filter('date')(data.DtAttivazione, 'dd/MM/yyyy');
            });
        }

        function updateAccount() {
            vm.account.DtAttivazione = common.stringToDate(vm.account.DtAttivazione);
            return datacontext.user_update(vm.account).then(function (data) {
                if (!data) {
                    vm.account.DtAttivazione = common.dateToString(vm.account.DtAttivazione);
                    logSuccess('Dato salvato');
                }
                else
                    logError('Impossibile salvare il dato');
            });
        }

        //Manda una email all'utente con un link di accesso al Reset Password
        //dove l'utente pu� inserire una nuova password per il suo account
        function resetPassword() {
            var msg = 'Sara\' inviata una email all\'utente ' + vm.account.Username + ' contenente le istruzioni per eseguire il reset della password. Continuare?';
            bDialog.confirmationDialog('Reset Password', msg, 'OK').then(function () {
                return datacontext.user_resetPassword(vm.account.Email).then(function (data) {
                    if (data != "204") return logError('Impossibile eseguire l\'operazione');

                    logSuccess('Operazione effettuata con successo ');
                });
            });
        }

        function invioCredenziali() {
            var msg = 'Sara\' inviata una email all\'utente ' + vm.account.Username + ' contenente le credenziali per l\'accesso alla piattaforma. Continuare?';
            bDialog.confirmationDialog('Invio Credenziali', msg, 'OK').then(function () {
                return datacontext.user_invioCredenziali(vm.account.Email).then(function (data) {
                    if (data != "204") return logError('Impossibile eseguire l\'operazione');
                    logSuccess('Operazione effettuata con successo ');
                });
            });
        }

        //Metodi di delete object List
        function deleteIncarico(item) {
            if (item.stat_OreLezioni > 0) {
                logError('Non &egrave; possibile eliminare una docente attivo dalla classe');
                return;
            }

            var msg = ' il docente '+ vm.record.Cognome + ' ' + vm.record.Nome + ' dalla classe ' + item.Classe;
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.incarico_delete(item.Id).then(function (data) {
                    if (data != "204") return logError('Errore durante la rimozione del dato');

                    getListIncarichi(vm.record.Id);
                });
            });
        }

        function deleteMateria(item) {
            var msg = ' la materia ' + item.Titolo;
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.super_materia_docenteDelete(vm.record.Id, item.Id).then(function (data) {
                    if (data != "204") return logError('Errore durante la rimozione del dato');

                    getListMaterie(vm.record.Id);
                });
            });
        }

        //****************************************************
        // OPEN MODAL DIALOG
        //****************************************************
        function addModal() {
            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/risorsa/modal/risorsaAdd.html?version=43',
                controller: 'risorsaAdd',
                resolve: {                                                            
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (!returnItem) return logError('Errore durante la creazione del dato ');

                logSuccess('Record creato con successo ');
                addRecord(returnItem.Id);
            });
        }

        //Materia
        function addMateria() {
            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/materia/modal/super_docenteMateriaAdd.html?version=43',
                controller: 'super_docenteMateriaAdd',
                resolve: {
                    docenteId: function () {
                        return vm.record.Id;
                    }
                }
            });
            modalInstance.result.then(function (returnItem) {
                getListMaterie(vm.record.Id);
            });
        }

        //Incarico
        function addIncarico() {
            var classi = getListClassi();
            var nominativo = vm.record.Cognome + ' ' + vm.record.Nome;
            var record = { Id: vm.record.Id, Name: nominativo };

            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/incarico/modal/incaricoAddEdit.html?version=43',
                controller: 'incaricoAddEdit',
                resolve: {
                    incarico: function () {
                        return null;
                    },
                    risorse: function () {
                        return [record];        //Carica Array con la sola risorsa visualizzata 
                    },
                    risorsaId: function () {
                        return vm.record.Id;    //RisorsaId impostata con record visualizzato
                    },
                    classi: function () {
                        return classi;
                    },
                    classeId: function () {
                        return null;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (!returnItem) return logError('Errore durante la creazione del dato ');

                logSuccess('Record creato con successo ');
                getListIncarichi(vm.record.Id);
            });
        }

        function editIncarico(incarico) {
            var classi = getListClassi();
            var nominativo = vm.record.Cognome + ' ' + vm.record.Nome;
            var record = { Id: vm.record.Id, Name: nominativo };

            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/incarico/modal/incaricoAddEdit.html?version=43',
                controller: 'incaricoAddEdit',
                resolve: {
                    incarico: function () {
                        return incarico;
                    },
                    risorse: function () {
                        return [record];        //Carica Array con la sola risorsa visualizzata 
                    },
                    risorsaId: function () {
                        return vm.record.Id;    //RisorsaId impostata con record visualizzato
                    },
                    classi: function () {
                        return classi;
                    },
                    classeId: function () {
                        return null;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (!returnItem) {
                    logSuccess('Dato salvato con successo');
                    getListIncarichi(vm.record.Id);
                }
                else
                    return logError('Errore durante il salvataggio del dato');
            });
        }
    }
})();
